import type { CheatCommand, CheatGroup, CheatPanelSpec } from "./types.js";

export function cheatGroup(
  id: string,
  label: string,
  opts: { readonly defaultExpanded?: boolean; readonly order?: number } = {},
): CheatGroup {
  return { id, label, defaultExpanded: opts.defaultExpanded ?? true, order: opts.order ?? 0 };
}

export function cheatCommand(command: CheatCommand): CheatCommand {
  return command;
}

export function defineCheatPanel(spec: CheatPanelSpec): CheatPanelSpec {
  return spec;
}
